import { type FC, memo, useState } from 'react'
import { set } from 'date-fns'

import Calendar from './_internal/Calendar'
import { DEFAULT_TIME } from './DatePicker.constants'
import { type DatePickerProps } from './DatePicker.types'
import { getTarget } from './DatePicker.utils'
import * as styles from './styles'

const DatePicker: FC<DatePickerProps> = ({
  endDate,
  initTarget = 'INIT',
  mode = 'ROUND_TRIP',
  onChange,
  scrollElementRef,
  startDate,
  ...rest
}) => {
  const [currentTarget, setCurrentTarget] = useState(initTarget)

  const setFixedHour = (day: Date): Date => set(day, { hours: DEFAULT_TIME, minutes: 0, seconds: 0, milliseconds: 0 })

  const onDaySelect = (day: Date) => {
    const target = getTarget({ day, startDate, mode, currentTarget })
    setCurrentTarget(target)

    let newStartDate
    let newEndDate

    if (!startDate || target === 'START') {
      newStartDate = day
      newEndDate = mode === 'ROUND_TRIP' ? undefined : endDate
    } else {
      newStartDate = startDate
      newEndDate = day
    }

    onChange(setFixedHour(newStartDate), newEndDate ? setFixedHour(newEndDate) : undefined)
  }

  return (
    <div css={styles.root} aria-hidden>
      <Calendar
        scrollElementRef={scrollElementRef}
        currentTarget={currentTarget}
        endDate={endDate && setFixedHour(endDate)}
        mode={mode}
        onDaySelect={onDaySelect}
        startDate={startDate ? setFixedHour(startDate) : undefined}
        {...rest}
      />
    </div>
  )
}

export default memo<DatePickerProps>(DatePicker)
